import { Vector3 } from "three";
import { ConversionStatus } from "../../common/constant";
import { DataIndexItem } from "../../types/interfaces";
import { updateDataItemOnServerStore } from "../../store/DataStore";

export const generateDataItem = (hash: string, ownerId: string, file: any, callBack?: ((body: any) => void) | undefined ) => {
    const dataItem: DataIndexItem = {
        data_id: hash,
        owner_id: ownerId,
        id_iterator: "",
        batch_iterator: "",
        name: file.name,
        raw_epsg: "",
        raw_epoch: "",
        raw_geoid: "",
        target_epsg: "",
        target_epoch: "",
        target_geoid: "",
        acquisition_date: "",
        acquisition_type: "",
        conversion_status: ConversionStatus.Uploading,
        raw_size: file.size,
        entwine_build_path: "",
        center: "",
        las_metadata: {},
        radius: "",
        project: "",
        permission_group: "",
        uuid: "",
        show: false,
        loaded: false,
        isProject: false,
        translationV3: new Vector3()
    };

    const [fileName, ext] = file.name.split(".");

    updateDataItemOnServerStore(
        {
            data_id: hash,
            owner_id: ownerId,
            name: fileName,
            raw_type: ext,
            conversion_status: ConversionStatus.Uploaded,
            reported_size: file.size
        },
        callBack
    );
};
